import { z } from 'zod';
export const offerRequestRematchUnavailableReasonSchema = z.enum([
    'NotMatched',
    // The copy does the matching.
    'Copied',
    // Not priced, outside the Zurich process, or Realtor.
    'NotEligible',
    // No hard filter changed since the latest run.
    'BoundsUnchanged',
    // Counted from the first run; a rematch doesn't reset it.
    'WaterfallClosed',
    // Every slot a rematch could still fill is held by a partner who accepted.
    'SlotsLocked',
]);
// State of the BackOps "Rematch request" CTA for one offer request.
export const offerRequestRematchAvailabilityResponseSchema = z.discriminatedUnion('isRematchAvailable', [
    z.object({ isRematchAvailable: z.literal(true), unavailableReason: z.null() }),
    z.object({ isRematchAvailable: z.literal(false), unavailableReason: offerRequestRematchUnavailableReasonSchema }),
]);
